import '../../../node_modules/flickity/css/flickity.css';
import '../../styles/collection.scss';
import '../../styles/collection.subsections.scss';
import '../../styles/flickity-page-dots.scss';
import '../../styles/top-messaging.scss';

import '../snippets/product-grid-item';

import 'waypoints/lib/noframework.waypoints.js';
import smoothscroll from 'smoothscroll-polyfill';

smoothscroll.polyfill();

function handlerDown(direction) {
  if (direction === 'down') {
    const secondaryMenuEl = document.querySelector('#secondary-menu');
    const secondaryMenuItemsNodelist = secondaryMenuEl.querySelectorAll('a');

    const {childIndex, handle} = this.element.dataset;

    secondaryMenuItemsNodelist.forEach((el, idx) => {
      if (idx == childIndex) {
        el.classList.add('active');
      } else {
        el.classList.remove('active');
      }
    });

    secondaryMenuEl.dataset.handle = handle;
  }
}

function handlerUp(direction) {
  if (direction === 'up') {
    const secondaryMenuEl = document.querySelector('#secondary-menu');
    const secondaryMenuItemsNodelist = secondaryMenuEl.querySelectorAll('a');

    const {childIndex, handle} = this.element.dataset;

    secondaryMenuItemsNodelist.forEach((el, idx) => {
      if (idx == childIndex) {
        el.classList.add('active');
      } else {
        el.classList.remove('active');
      }
    });

    secondaryMenuEl.dataset.handle = handle;
  }
}

function offsetDown() {
  const offset =
    document.querySelector('#shopify-section-header').clientHeight +
    document.querySelector('#secondary-menu').clientHeight;
  return offset;
}

function offsetUp() {
  const offset =
    document.querySelector('#shopify-section-header').clientHeight +
    document.querySelector('#secondary-menu').clientHeight -
    this.element.clientHeight;
  return offset;
}

document.addEventListener('DOMContentLoaded', (event) => {
  new Waypoint({
    element: document.querySelector('.collection-title'),
    offset: offsetUp,
    handler: () => {
      document.querySelectorAll('#secondary-menu a').forEach((el) => {
        el.classList.remove('active');
      });
      document.querySelector('#secondary-menu').removeAttribute('data-handle');
    },
  });

  document.querySelectorAll('.subsection').forEach((element) => {
    new Waypoint({
      element,
      handler: handlerDown,
      offset: offsetDown,
    });
    new Waypoint({
      element,
      handler: handlerUp,
      offset: offsetUp,
    });
  });

  document
  .querySelector('.collection--subsections')
  .addEventListener('click', (event) => {
    if (event.target.parentNode.classList.contains('secondary-menu__inner')) {
      event.preventDefault();
      const anchorSelector = event.target.getAttribute('href');

      const scrollTopGoal =
        document.querySelector(anchorSelector).offsetTop -
        document.querySelector('#shopify-section-header').clientHeight -
        document.querySelector('#secondary-menu').clientHeight;

      window.scrollTo({
        top: scrollTopGoal,
        behavior: 'smooth',
      });
      history.replaceState(null, null, anchorSelector);
    }
  });
});
